module.exports = "/_next/static/images/wirelessCom1-d7b05f89613c56ae9ef21e5d3c58e729.webp";